import data from "../../../../../src/BranchName.docs.json";
import * as React from 'react';
export default {
  data,
  React
};